import { render, staticRenderFns } from "./差異分析.vue?vue&type=template&id=5080f17f&"
import script from "./差異分析.ts?vue&type=script&lang=ts&"
export * from "./差異分析.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports